import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MmuDeviceProductGroupIconPipe } from './device-product-group-icon/device-product-group-icon.pipe';
import { MmuDeviceProductGroupLabelPipe } from './device-product-group-label/device-product-group-label.pipe';
import { MmuDeviceTypeIconPipe } from './device-type-icon/device-type-icon.pipe';
import { MmuDeviceTypeLabelPipe } from './device-type-label/device-type-label.pipe';


@NgModule({
  declarations: [
    MmuDeviceTypeIconPipe,
    MmuDeviceTypeLabelPipe,
    MmuDeviceProductGroupLabelPipe,
    MmuDeviceProductGroupIconPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MmuDeviceTypeIconPipe,
    MmuDeviceTypeLabelPipe,
    MmuDeviceProductGroupLabelPipe,
    MmuDeviceProductGroupIconPipe
  ]
})
export class MmuDevicesModule {
}
